import React from 'react';
import { injectIntl } from 'react-intl';
import { Checkbox } from 'semantic-ui-react';
import EditIcon from '../../../../assets/add-ons/edit.svg';
import AddOnListToolTip from '../../../tooltip/addOnListToolTip';
import styles from '../styles-module.css';
import { locale } from './../locale';
import { ACTIVE } from '../../consts';

const AddOnRow = injectIntl((props) => {
  const { addOn, rate, index, hasPermissionForManageAddOns, history, isDisabled, isAllSoldOut } = props;
  const displayEditButton = () => {
    return (
      <div className={`${styles.column} ${styles.actions}`}>
        <div className={styles.editIcon}>
          <button
            className="ui fluid icon button"
            onClick={() => history.push(`/dashboard/add-ons/edit/${addOn.id}`)}
          >
            <EditIcon />
          </button>
        </div>
        <div className={styles.trashDeleteIcon}>
          <button className="ui fluid icon button" onClick={() => props.onAddOnsDelete(index)} disabled={isDisabled}>
            <i aria-hidden="true" className="grey large icon universe-delete"/>
          </button>
        </div>
      </div>
    );
  }

  const firstRate = rate?.[0];
  const imageUrl = firstRate?.imageUrl;
  const imageContainer = imageUrl &&
    <div className={styles.column}>
      <img src={imageUrl} className={styles.addOnImage} alt="addon_photo" />
    </div>;
  const addOnColumnClasses = `${styles.column} ${styles.addOn} ${imageUrl && styles.withImage}`;
  const selectedTicketTypesIndicator = () => {
    const selectedCustomisation = addOn?.addOnCustomizations.some(value => value.capacityLimit === null);
    return (
      <div>
        { selectedCustomisation
          ? props.intl.formatMessage(locale.specificTicketTypesSelectedIndicators)
          : props.intl.formatMessage(locale.allTicketTypesSelectedIndicators)
        }
      </div>);
  }

  const selectedTimeslotIndicator = () => {
    return (
      <div>
        { addOn?.addOnAvailabilityRules.length > 0
          ? props.intl.formatMessage(locale.specificTimeslot)
          : props.intl.formatMessage(locale.allTimeslot)
        }
      </div>);
  }

  const renderAddOnOptions = () => {
    if (addOn?.rates?.length > 1) {
      return addOn?.rates?.map(r=> <div className={styles.option} key={r.id}>{r.optionName}</div>);
    }
    return props.intl.formatMessage(locale.noOptions);
  }

  return (
    <div className={`${styles.desktopAddOnRow}`} key={addOn}>
      <div className={`${styles.column} ${styles.status} ${styles.toggleCell}`}>
        <Checkbox
          disabled={isAllSoldOut}
          toggle
          checked={firstRate?.state === ACTIVE}
          onChange={(_, { checked }) => props.onAddOnsStatusChange(index, checked)}
        />
      </div>
      <div className={addOnColumnClasses}>
        {imageContainer}
        <div>
          <div className={styles.addOnName}>{addOn.name}</div>
          <div className={styles.sku}>{firstRate?.sku}</div>
        </div>  
      </div>
      <div className={`${styles.column} ${styles.options}`}>
        {renderAddOnOptions()}
      </div>
      <div className={`${styles.column} ${styles.price}`}>{props.formatPrices()}</div>
      <div className={`${styles.column} ${styles.available}`}>{props.formatAvailable()}</div>
      <div className={`${styles.column} ${styles.appliesTo}`}>
        {addOn?.events ? <AddOnListToolTip listings={addOn?.events} addOn={addOn} /> : null}
        {selectedTicketTypesIndicator()}
        {selectedTimeslotIndicator()}
      </div>
      {hasPermissionForManageAddOns && displayEditButton()}
    </div>
  );
});

export default AddOnRow;
